import type { Span, SpanNode } from '@repo/shared';

import { TreeNode } from '@/routes/(app)/(tracing)/components/trace-tree-view';

export const TreeView = ({ tree }: { tree: Array<SpanNode> }) => (
  <ul>
    {tree.map((node) => (
      <TreeNode
        key={node.id}
        node={node}
      />
    ))}
  </ul>
);

function buildTree(
  items: Array<Span>,
  parentSpanId: string | null = null
): Array<SpanNode> {
  return items
    .filter((item) => item.parentSpanId === parentSpanId)
    .map((item) => ({
      ...item,
      children: buildTree(items, item.id),
    }));
}

export const SpanView = ({ trace }: { trace: Array<Span> }) => {
  // SQL query sorts by startTime in descending order, so we need to reverse and copy the array for spans to show in correct order
  const tree = buildTree(trace.concat([]).reverse());

  return <TreeView tree={tree} />;
};
